import { createReducer, on } from '@ngrx/store';
import { cloneDeep } from 'lodash';
import { QuestionnaireQuickAccessModalActions } from './quick-access-modal.actions';
import {
  QuestionnaireQuickAccessModalState,
  questionnaireQuickAccessModalState
} from './quick-access-modal.state';

export const questionnaireQuickAccessModalReducer = createReducer(
  questionnaireQuickAccessModalState,
  on(
    QuestionnaireQuickAccessModalActions.reset,
    (): QuestionnaireQuickAccessModalState => questionnaireQuickAccessModalState
  ),
  on(
    QuestionnaireQuickAccessModalActions.updateAccessQuestionnaire,
    (state, { accessQuestionnaire }): QuestionnaireQuickAccessModalState => ({
      ...state,
      accessQuestionnaire
    })
  ),
  on(
    QuestionnaireQuickAccessModalActions.updateIsBeingProcessed,
    (state, { isBeingProcessed }): QuestionnaireQuickAccessModalState => ({
      ...state,
      isBeingProcessed
    })
  ),
  on(
    QuestionnaireQuickAccessModalActions.updateReportType,
    (state, { reportType }): QuestionnaireQuickAccessModalState => ({
      ...state,
      reportType
    })
  ),
  on(
    QuestionnaireQuickAccessModalActions.updateStatus,
    (state, { status }): QuestionnaireQuickAccessModalState => ({
      ...state,
      status
    })
  ),
  on(
    QuestionnaireQuickAccessModalActions.updateLoading,
    (state, { questionnaireCheck }): QuestionnaireQuickAccessModalState => ({
      ...state,
      loading: {
        ...state.loading,
        questionnaireCheck
      }
    })
  ),
  on(
    QuestionnaireQuickAccessModalActions.updateRedirectTo,
    (state, { redirectTo }): QuestionnaireQuickAccessModalState => ({
      ...state,
      redirectTo
    })
  ),
  on(
    QuestionnaireQuickAccessModalActions.checkIfCanFillOutTheQuestionnaire,
    (
      state,
      { reportType = null, redirectTo = null }
    ): QuestionnaireQuickAccessModalState => {
      const questionnaireStatusQuery = cloneDeep(
        state.questionnaireStatusQuery
      );
      if (reportType) {
        if (questionnaireStatusQuery[reportType]) {
          questionnaireStatusQuery[reportType] = {
            ...questionnaireStatusQuery[reportType],
            loading: true,
            error: null,
            queryCount: questionnaireStatusQuery[reportType].queryCount + 1
          };
        } else {
          questionnaireStatusQuery[reportType] = {
            loading: true,
            result: null,
            error: null,
            queryCount: 1
          };
        }
      }
      return {
        ...state,
        reportType,
        redirectTo,
        questionnaireStatusQuery
      };
    }
  ),
  on(
    QuestionnaireQuickAccessModalActions.checkIfCanFillOutTheQuestionnaireSuccess,
    (
      state,
      { reportType = null, status }
    ): QuestionnaireQuickAccessModalState => {
      const questionnaireStatusQuery = cloneDeep(
        state.questionnaireStatusQuery
      );
      if (reportType) {
        if (questionnaireStatusQuery[reportType]) {
          questionnaireStatusQuery[reportType] = {
            ...questionnaireStatusQuery[reportType],
            loading: false,
            result: status,
            error: null
          };
        } else {
          questionnaireStatusQuery[reportType] = {
            loading: false,
            result: status,
            error: null,
            queryCount: 1
          };
        }
      }
      return {
        ...state,
        reportType,
        questionnaireStatusQuery
      };
    }
  ),
  on(
    QuestionnaireQuickAccessModalActions.checkIfCanFillOutTheQuestionnaireFailed,
    (
      state,
      { reportType = null, error }
    ): QuestionnaireQuickAccessModalState => {
      const questionnaireStatusQuery = cloneDeep(
        state.questionnaireStatusQuery
      );
      if (reportType) {
        if (questionnaireStatusQuery[reportType]) {
          questionnaireStatusQuery[reportType] = {
            ...questionnaireStatusQuery[reportType],
            loading: false,
            result: 'NOT_FOUND',
            error: {
              message: error.message
            }
          };
        } else {
          questionnaireStatusQuery[reportType] = {
            queryCount: 1,
            loading: false,
            result: 'NOT_FOUND',
            error: {
              message: error.message
            }
          };
        }
      }
      return {
        ...state,
        reportType,
        questionnaireStatusQuery
      };
    }
  )
);
